<template>
  <div class="Sport">
    <SportAchieve />
  </div>
</template>

<script>
import SportAchieve from "@/components/achieve/SportAchieve.vue";

export default {
  name: "Sport",
  components: {
    SportAchieve
  }
};
</script>
